import { Formik, Form, Field } from 'formik'
import Arrive from './components/Arrive'
import Departure from './components/Departure'
import Bedrooms from './components/Bedrooms'
import Guests from './components/Guests'
import Button from '../../../../../../elements/Button'
import Grid from '../../../../../../elements/Grid'
import styles from './styles.module.scss'
import { useRef, useState, useEffect } from 'react'
import IconExternal from '/public/icons/icon-external.svg'
import { useResponsive } from '../../../../../../../providers/ResponsiveContext'
import { withModifiers } from '/components/helpers/withModifiers'
import { useSearchContext } from '/providers/SearchContext'
import { useModalContext } from '/providers/modalProvider'
import ModalContent from './components/ModalContent'
import ContactForm from '/components/pages/common/Contact/components/ContactForm'
import axios from '/components/configs/axios'
import { withComma } from '/components/helpers/withComma'
import { useAuthContext } from '/providers/authProvider'
import { useRouter } from 'next/router'

const Reservation = ({
  expandable,
  show,
  property,
  setShow,
  blockedDates,
  minNights,
  setBonuses,
  bonuses,
  translations
}) => {
  const { initialValues, search, bedroomOptions, guests } = useSearchContext()
  const { loggedIn } = useAuthContext()
  const ref = useRef(null)
  const router = useRouter()
  const { isDesktop, isTablet } = useResponsive()
  const { setContent, handleShowModal, setVariant } = useModalContext()
  const [loading, setLoading] = useState(false)

  const [startingPrice, setStartingPrice] = useState(0)
  const [width, setWidth] = useState(0)

  const formInitialValues = {
    startDate: initialValues?.startDate,
    endDate: initialValues?.endDate,
    bedrooms: [],
    guests: guests
  }

  //TODO: cleanup and reorganize this whole component

  // set the panel open width on page load
  useEffect(() => {
    setTimeout(
      () => setWidth(ref.current?.getBoundingClientRect().width - 80),
      1000
    )
  }, [])

  useEffect(() => {
    setTimeout(
      () => setWidth(ref.current?.getBoundingClientRect().width - 80),
      1000
    )
  }, [show, isDesktop, isTablet])

  const [nights, setNights] = useState(false)
  const [taxes, setTaxes] = useState(false)
  const [total, setTotal] = useState(false)
  const [totalWithoutStripe, setTotalWithoutStripe] = useState(false)
  const [numberOfFreeNights, setNumberOfFreeNights] = useState(false)
  const [freeNightsCost, setFreeNightsCost] = useState(false)
  const [freeNightsOldPrice, setFreeNightsOldPrice] = useState(false)
  const [price, setPrice] = useState(0)
  let disabled =
    search?.startDate === null ||
    search?.endDate === null ||
    guests === null ||
    bedroomOptions === '' ||
    !property.is_active

  useEffect(() => {
    if (search.startDate && search.endDate && bedroomOptions && guests) {
      setLoading(true)
      const endDate = search?.endDate?.clone().startOf('day')
      setNights(endDate.diff(search.startDate.clone().startOf('day'), 'days'))

      axios
        .post('reservation/price-calculation', {
          lang: router.locale,
          id: property?.resource_id,
          startDate: search.startDate
            .clone()
            .startOf('day')
            .format('YYYY-MM-DD'),
          endDate: search.endDate.clone().startOf('day').format('YYYY-MM-DD'),
          bedrooms: bedroomOptions
        })
        .then((res) => {
          const result = res.data
          setPrice(result.totalCostPerNights)
          setTaxes(result.tax10)
          setTotalWithoutStripe(result.totalWith10Taxes)
          setTotal(result.finalCost)
          setNumberOfFreeNights(result.freeNights)
          setFreeNightsCost(result.freeNightlyRate)
          setFreeNightsOldPrice(result.initial)
          setLoading(false)
        })
        .catch((err) => console.error(err))
    }
  }, [search, bedroomOptions, guests, router.locale])

  useEffect(() => {
    axios
      .get('listings/starting-price', {
        params: {
          lang: router.locale,
          startDate: search.startDate
            ?.clone()
            .startOf('day')
            .format('YYYY-MM-DD'),
          endDate: search.endDate?.clone().startOf('day').format('YYYY-MM-DD'),
          bedrooms: bedroomOptions,
          listingId: property?.resource_id
        }
      })
      .then((res) => {
        const carBonusExists =
          res.data.bonuses && res.data.bonuses.includes('free_car')
        const nightBonusExists =
          res.data.bonuses && res.data.bonuses.includes('free_night')
        const giftBonusExists =
          res.data.bonuses && res.data.bonuses.includes('free_gift')
        setBonuses((prevBonuses) => ({
          ...prevBonuses,
          car: carBonusExists,
          gift: giftBonusExists,
          night: nightBonusExists
        }))
        setStartingPrice(res.data.starting_at)
      })
      .catch((err) => console.error(err))
  }, [
    search.startDate,
    search.endDate,
    bedroomOptions,
    property,
    guests,
    setBonuses,
    router.locale
  ])

  // set the minimum price out of all the bedroom options

  return (
    <div>
      <Formik enableReinitialize initialValues={formInitialValues}>
        {() => {
          const defaultProps = {
            variant: ['full-width', 'footer-close'],
            footer: false,
            width: width,
            property: property,
            required: true
          }

          return (
            <Form className={styles.formik} ref={ref}>
              <div
                className={withModifiers(
                  'form',
                  [isDesktop && expandable && show && 'is-hidden'],
                  styles
                )}
              >
                {!blockedDates && (
                  <div className={styles.form__nights}>
                    {translations.bookingNoLoad[router.locale]}
                  </div>
                )}
                <Grid
                  variant={['grid-2', isDesktop && 'column-2xl', 'spacing-xs']}
                >
                  <Field
                    blockedDates={blockedDates}
                    component={Arrive}
                    label={translations?.arrive[router.locale]}
                    {...defaultProps}
                  />

                  <Field
                    blockedDates={blockedDates}
                    label={translations?.depart[router.locale]}
                    component={Departure}
                    {...defaultProps}
                  />

                  <Field
                    component={Guests}
                    label={translations?.guests[router.locale]}
                    {...defaultProps}
                  />

                  <Field
                    component={Bedrooms}
                    translations={translations}
                    {...defaultProps}
                  />
                </Grid>
                <div className={styles.form__pricing}>
                  {search?.startDate &&
                  search?.endDate &&
                  guests &&
                  minNights <= nights &&
                  bedroomOptions !== '' ? (
                    <>
                      <div className={styles.form__row}>
                        <div>${withComma(price)}</div>

                        <div>${withComma(price)}</div>
                      </div>

                      <div className={styles.form__row}>
                        <div>{translations.taxesFees[router.locale]}</div>

                        <div>${withComma(parseFloat(taxes).toFixed(2))}</div>
                      </div>

                      <div className={styles.form__row}>
                        <div>{translations.total[router.locale]}</div>

                        <div>${withComma(totalWithoutStripe)}</div>
                      </div>
                    </>
                  ) : (
                    <>
                      {translations?.startingAt[router.locale]}{' '}
                      <span className={styles.form__number}>
                        ${withComma(startingPrice)}
                      </span>{' '}
                      {!(search.startDate && search.endDate) &&
                        translations?.perNight[router.locale]}
                    </>
                  )}

                  {minNights && (
                    <div className={styles.form__nights}>
                      <span>{minNights}</span>{' '}
                      {translations?.minNights[router.locale]}
                    </div>
                  )}
                </div>

                {isTablet && (
                  <Button
                    className={styles.form__button}
                    disabled={disabled}
                    type="button"
                    onClick={() => {
                      if (disabled) {
                        setShow(!show)
                      } else if (minNights > nights || !blockedDates) {
                        setContent(
                          <div>
                            <h2 className={styles.form__title}>
                              {translations.contactDetails[router.locale]}
                            </h2>

                            <p className={styles.form__subtitle}>
                              {blockedDates
                                ? translations.lessDays[router.locale]
                                : translations.issueLoading[router.locale]}
                            </p>

                            <ContactForm
                              total={total}
                              translations={translations}
                              startDate={search.startDate.format('YYYY-MM-DD')}
                              endDate={search.endDate.format('YYYY-MM-DD')}
                              propertyName={property?.propertyTitle}
                              bedrooms={bedroomOptions}
                              guests={guests}
                              route={
                                blockedDates ? 'email/send' : 'email/payment'
                              }
                            />
                          </div>
                        )
                        setVariant(['contained'])
                        handleShowModal()
                      } else {
                        setContent(
                          <ModalContent
                            numberOfFreeNights={numberOfFreeNights}
                            freeNightsCost={freeNightsCost}
                            freeNightsOldPrice={freeNightsOldPrice}
                            totalWithoutStripe={totalWithoutStripe}
                            total={total}
                            taxesAndFess={taxes}
                            totalCostPerNights={price}
                            startDate={search.startDate.format('YYYY-MM-DD')}
                            endDate={search.endDate.format('YYYY-MM-DD')}
                            propertyId={property?.resource_id}
                            bedrooms={bedroomOptions}
                            property={property}
                            guests={guests}
                            translations={translations}
                            bonuses={bonuses}
                          />
                        )
                        setVariant(['contained'])
                        handleShowModal()
                      }
                    }}
                    variant={[expandable && !show && 'full-width', 'gold']}
                    arrow={false}
                  >
                    {translations?.book[router.locale]}
                  </Button>
                )}
              </div>

              {!isTablet && (
                <Button
                  className={styles.form__button}
                  disabled={isDesktop ? !show && disabled : disabled || loading}
                  type="button"
                  onClick={() => {
                    if (disabled) {
                      setShow(!show)
                    } else if (minNights > nights || !blockedDates) {
                      setContent(
                        <div>
                          <h2 className={styles.form__title}>
                            {translations.contactDetails[router.locale]}
                          </h2>

                          <p className={styles.form__subtitle}>
                            {blockedDates
                              ? translations.lessDays[router.locale]
                              : translations.issueLoading[router.locale]}
                          </p>

                          <ContactForm
                            translations={translations}
                            variant={['dark']}
                            total={total}
                            startDate={search.startDate.format('YYYY-MM-DD')}
                            endDate={search.endDate.format('YYYY-MM-DD')}
                            propertyName={property?.propertyTitle}
                            bedrooms={bedroomOptions}
                            guests={guests}
                            route={
                              blockedDates ? 'email/send' : 'email/payment'
                            }
                          />
                        </div>
                      )
                      setVariant(['contained'])
                      handleShowModal()
                    } else {
                      setContent(
                        <ModalContent
                          translations={translations}
                          numberOfFreeNights={numberOfFreeNights}
                          freeNightsCost={freeNightsCost}
                          freeNightsOldPrice={freeNightsOldPrice}
                          total={total}
                          totalWithoutStripe={totalWithoutStripe}
                          startDate={search.startDate.format('YYYY-MM-DD')}
                          taxesAndFess={taxes}
                          totalCostPerNights={price}
                          endDate={search.endDate.format('YYYY-MM-DD')}
                          propertyId={property?.resource_id}
                          listingId={property?.id}
                          bedrooms={bedroomOptions}
                          property={property}
                          guests={guests}
                          bonuses={bonuses}
                        />
                      )
                      setVariant(['contained'])
                      handleShowModal()
                    }
                  }}
                  variant={[expandable && !show && 'full-width', 'gold']}
                  arrow={false}
                >
                  {translations.book[router.locale]}
                </Button>
              )}

              {((isTablet && !show) || !isTablet) &&
                loggedIn &&
                property?.attachment?.rate_sheet && (
                  <Button
                    href={property.attachment.rate_sheet}
                    arrow={false}
                    target="_blank"
                    appendIcon={<IconExternal />}
                    variant={['label', 'm-t-xl']}
                    type="button"
                  >
                    {translations.download[router.locale]}
                  </Button>
                )}
            </Form>
          )
        }}
      </Formik>
    </div>
  )
}

export default Reservation
